module.exports = __webpack_public_path__ + "img/broadcast.5b4b48d7.svg";